import axios, { AxiosInstance } from "axios";

interface UserSession {
    value: {
        accessToken: string;
        refreshToken: string;
    };
}

const getUserSession = (): UserSession | null => {
    if (typeof window === "undefined") return null;
    const sessionStr = localStorage.getItem("userSession");
    return sessionStr ? JSON.parse(sessionStr) : null;
};

export const getAccessTokenFromSession = (): string | null => {
    const session = getUserSession();
    return session?.value?.accessToken ?? null;
};

export const updateUserSession = (newAccessToken: string, newRefreshToken: string): void => {
    if (typeof window === "undefined") return;
    const session = getUserSession();
    if (session) {
        const updatedSession = {
            ...session,
            value: {
                ...session.value,
                accessToken: newAccessToken,
                refreshToken: newRefreshToken,
            },
        };
        localStorage.setItem("userSession", JSON.stringify(updatedSession));
    }
};

export const createJWTToken = (tokenValue: string | null): string => (tokenValue ? `Bearer ${tokenValue}` : "");

const createAxiosInstance = (): AxiosInstance =>
    axios.create({
        headers: {
            "Content-Type": "application/json",
            Authorization: createJWTToken(getAccessTokenFromSession()),
            "Missgo-Service": "missgoauction.com",
        },
    });

export const axiosInstance = createAxiosInstance();
